import { CapoPlugin } from "/home/vsts/work/1/s/zenapptic-website-nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];